var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({style:({ fontSize: _vm.large ? '4em' : '1em', display: _vm.inline ? 'inline-block' : 'block', textAlign: 'center' })},'div',_vm.$attrs,false),[_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":"","fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }